import styles from '@styles/scss/performer/_performerVideos.module.scss';
import addScript from 'lib/functions/videoScript';
import { Performer } from 'lib/types/item/performer';
import { useEffect, useRef } from 'react';

export default function LightBox({
    videos,
    current,
    lightBox,
    sendLightBox,
    sendBlur,
    threeVideos,
    performer,
    recordedVideoAmount,
    thumbnailPath
}: {
    videos: any;
    current: number;
    lightBox: boolean;
    sendLightBox: any;
    sendBlur: any;
    threeVideos: boolean;
    performer: Performer;
    recordedVideoAmount: number;
    thumbnailPath: string;
}): JSX.Element {
    const index = 0;
    const length = videos.length;

    function outsideLightBox(ref: any, ref2: any, ref3: any) {
        /* handles clicking anywhere outside of the chevrons or the lightbox to close it,
      and remove the blur */
        useEffect(() => {
            function handleClickOutside(event: any) {
                if (
                    length === 2 &&
                    ref.current &&
                    !ref.current.contains(event.target) &&
                    ref2.current &&
                    !ref2.current.contains(event.target) &&
                    ref3.current &&
                    !ref3.current.contains(event.target)
                ) {
                    addScript(videos);
                    sendLightBox(false);
                } else if (
                    length + recordedVideoAmount === 1 &&
                    ref.current &&
                    !ref.current.contains(event.target)
                ) {
                    addScript(videos);
                    sendLightBox(false);
                    sendBlur('');
                }
            }

            document.addEventListener('mousedown', handleClickOutside);
            return () => {
                document.removeEventListener('mousedown', handleClickOutside);
            };
        }, [ref]);
    }

    const blurRef = useRef(null);
    const rightRef = useRef(null);
    const leftRef = useRef(null);
    outsideLightBox(blurRef, rightRef, leftRef);

    return (
        <>
            {lightBox ? (
                <div className={styles.lightBox}>
                    {index === current ? (
                        /* eslint-disable-next-line jsx-a11y/media-has-caption */
                        <video
                            ref={blurRef}
                            className={styles.lightBoxVideo}
                            controls
                            autoPlay
                            poster={`https://s3.amazonaws.com/assets.camrabbit.sex/${thumbnailPath}`}>
                            <source
                                src={`https://s3.amazonaws.com/assets.camrabbit.sex/${performer.videos[0].path}`}
                                type="video/mp4"
                            />
                        </video>
                    ) : null}
                    {index + recordedVideoAmount === current ? (
                        <div
                            ref={blurRef}
                            className={styles.lightBoxVideo}
                            data-awe-container-id="video-player-0"></div>
                    ) : null}
                    {threeVideos || index + 2 + recordedVideoAmount === current ? (
                        <div
                            ref={blurRef}
                            className={styles.lightBoxVideo}
                            data-awe-container-id="video-player-2"></div>
                    ) : null}
                    {index + 1 + recordedVideoAmount === current ? (
                        <div
                            ref={blurRef}
                            className={styles.lightBoxVideo}
                            data-awe-container-id="video-player-1"></div>
                    ) : null}
                </div>
            ) : null}
        </>
    );
}
